import { useEffect, useState } from "react";
import { getProvinces, getDistricts, getWards } from "../../../api/LocationInfo";

interface LocationItem {
    code: string;
    name: string;
}

export default function AddAddressModal({
    onClose,
    onSubmit,
    initialData,
}: {
    onClose: () => void;
    onSubmit: (data: any) => void;
    initialData?: any;
}) {
    const [name, setName] = useState(initialData?.name || "");
    const [phone, setPhone] = useState(initialData?.phone || "");
    const [address, setAddress] = useState(initialData?.address || "");
    const [province, setProvince] = useState(initialData?.province || "");
    // const [district, setDistrict] = useState(initialData?.district || "");
    const [ward, setWard] = useState(initialData?.ward || "");

    const [provinces, setProvinces] = useState<LocationItem[]>([]);
    // const [districts, setDistricts] = useState<LocationItem[]>([]);
    const [wards, setWards] = useState<LocationItem[]>([]);

    useEffect(() => {
        const fetchProvinces = async () => {
            try {
                const data = await getProvinces();
                setProvinces(data);
                if (initialData?.province && isNaN(Number(initialData.province))) {
                    const p = data.find(item => item.name === initialData.province);
                    if (p) setProvince(String(p.code));
                }
            } catch (error) {
                console.error("Failed to fetch provinces", error);
            }
        };
        fetchProvinces();
    }, [initialData?.province]);

    // useEffect(() => {
    //     if (province && !isNaN(Number(province))) {
    //         const fetchDistricts = async () => {
    //             try {
    //                 const data = await getDistricts(province);
    //                 setDistricts(data);
    //                 if (initialData?.district && isNaN(Number(initialData.district))) {
    //                     const d = data.find(item => item.name === initialData.district);
    //                     if (d) setDistrict(String(d.id));
    //                 }
    //             } catch (error) {
    //                 console.error("Failed to fetch districts", error);
    //             }
    //         };
    //         fetchDistricts();
    //     } else {
    //         setDistricts([]);
    //         setWards([]);
    //     }
    // }, [province, initialData?.district]);

    useEffect(() => {
        if (province && !isNaN(Number(province))) {
            const fetchWards = async () => {
                try {
                    const data = await getWards(province);
                    setWards(data);
                    if (initialData?.ward && isNaN(Number(initialData.ward))) {
                        const w = data.find(item => item.name === initialData.ward);
                        if (w) setWard(String(w.code));
                    }
                } catch (error) {
                    console.error("Failed to fetch wards", error);
                }
            };
            fetchWards();
        } else {
            setWards([]);
        }
    }, [province, initialData?.ward]);

    const handleSubmit = () => {
        if (name && phone && address && province && ward) {
            const pName = provinces.find(p => String(p.code) === String(province))?.name || province;
            // const dName = districts.find(d => String(d.id) === String(district))?.name || district;
            const wName = wards.find(w => String(w.code) === String(ward))?.name || ward;

            onSubmit({
                name,
                phone,
                address,
                province: pName,
                // district: dName,
                ward: wName,
            });
        }
    };

    const isValid = name && phone && address && province && ward;

    return (
        <div
            role="presentation"
            className="MuiDialog-root styles_address_dialog__T1Iir"
            style={{ position: "fixed", inset: 0, zIndex: 1300 }}
        >
            <div className="MuiBackdrop-root" onClick={onClose} />

            <div className="MuiDialog-container MuiDialog-scrollPaper">
                <div className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm MuiPaper-elevation24 MuiPaper-rounded">
                    {/* HEADER */}
                    <div className="MuiDialogTitle-root">
                        <h2 className="MuiTypography-root MuiTypography-h6">
                            {initialData ? "Sửa thông tin giao hàng" : "Thêm thông tin giao hàng"}
                            <button
                                className="MuiButtonBase-root MuiIconButton-root styles_close_button__0HW_k"
                                type="button"
                                onClick={onClose}
                            >
                                <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></span>
                            </button>
                        </h2>
                    </div>

                    {/* CONTENT */}
                    <div className="MuiDialogContent-root">
                        <div className="MuiFormControl-root MuiTextField-root jss35 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required"
                                htmlFor="name"
                                id="name-label"
                            >
                                Họ và tên khách hàng
                                <span aria-hidden="true" className="MuiInputLabel-asterisk">
                                    &thinsp;*
                                </span>
                            </label>
                            <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                                <input
                                    className="MuiInputBase-input MuiFilledInput-input"
                                    placeholder="Tên"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="MuiFormControl-root MuiTextField-root jss35 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required"
                                htmlFor="name"
                                id="name-label"
                            >
                                Số điện thoại
                                <span aria-hidden="true" className="MuiInputLabel-asterisk">
                                    &thinsp;*
                                </span>
                            </label>
                            <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                                <input
                                    className="MuiInputBase-input MuiFilledInput-input"
                                    placeholder="Nhập số điện thoại"
                                    value={phone}
                                    onChange={e => setPhone(e.target.value.replace(/\D/g, ""))}
                                />
                            </div>
                        </div>

                        <div className="MuiFormControl-root MuiTextField-root jss35 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required"
                                htmlFor="address"
                                id="address-label"
                            >
                                Địa chỉ
                                <span aria-hidden="true" className="MuiInputLabel-asterisk">
                                    &thinsp;*
                                </span>
                            </label>
                            <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl">
                                <input
                                    type="text"
                                    className="MuiInputBase-input MuiFilledInput-input"
                                    placeholder="Nhập địa chỉ"
                                    value={address}
                                    onChange={e => setAddress(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="MuiFormControl-root MuiTextField-root jss22 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                data-shrink="true"
                                htmlFor="province"
                            >
                                Tỉnh/Thành phố
                                <span
                                    aria-hidden="true"
                                    className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                >
                                    &thinsp;*
                                </span>
                            </label>

                            <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                <select
                                    className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                    value={province}
                                    onChange={(e) => {
                                        setProvince(e.target.value);
                                        // setDistrict("");
                                        setWard("");
                                    }}
                                    id="province"
                                    required
                                >
                                    <option value="">Tỉnh/Thành phố</option>
                                    {provinces.map((p) => (
                                        <option key={p.code} value={p.code}>{p.name}</option>
                                    ))}
                                </select>

                                <svg
                                    className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                        </div>

                        {/* <div className="MuiFormControl-root MuiTextField-root jss22 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                data-shrink="true"
                                htmlFor="district"
                            >
                                Quận/Huyện
                                <span
                                    aria-hidden="true"
                                    className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                >
                                    &thinsp;*
                                </span>
                            </label>

                            <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                <select
                                    className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                    value={district}
                                    onChange={(e) => {
                                        setDistrict(e.target.value);
                                        setWard("");
                                    }}
                                    id="district"
                                    required
                                    disabled={!province}
                                >
                                    <option value="">Quận/Huyện</option>
                                    {districts.map((d) => (
                                        <option key={d.id} value={d.id}>{d.name}</option>
                                    ))}
                                </select>

                                <svg
                                    className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                        </div> */}

                        <div className="MuiFormControl-root MuiTextField-root jss22 !w-full">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled Mui-required Mui-required"
                                data-shrink="true"
                                htmlFor="ward"
                            >
                                Phường/Xã
                                <span
                                    aria-hidden="true"
                                    className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                                >
                                    &thinsp;*
                                </span>
                            </label>

                            <div className="MuiInputBase-root MuiFilledInput-root jss66 MuiInputBase-formControl">
                                <select
                                    className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input"
                                    value={ward}
                                    onChange={(e) => setWard(e.target.value)}
                                    id="ward"
                                    required
                                    disabled={!province}
                                >
                                    <option value="">Phường/Xã</option>
                                    {wards.map((w) => (
                                        <option key={w.code} value={w.code}>{w.name}</option>
                                    ))}
                                </select>

                                <svg
                                    className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* ACTION */}
                    <div className="MuiDialogActions-root MuiDialogActions-spacing">
                        <button
                            className={`MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR my-order__button my-order__button--green bg-gradient ${!isValid ? 'Mui-disabled' : ''}`}
                            type="button"
                            onClick={handleSubmit}
                            disabled={!isValid}
                        >
                            {initialData ? "Cập nhật" : "Thêm"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
